// extracted by mini-css-extract-plugin
module.exports = {"unit":"8px","questionText":"multi-text-question__questionText____2Sl51","hintText":"multi-text-question__hintText____3CKuv","input":"multi-text-question__input____sn0DN"};